import type { IContextualMenuItem } from '@fluentui/react/lib/ContextualMenu';

const VIEW_SWITCHER_MENU_WIDTH = 150;

export function getViewSwitcherSubMenuProps(menuItems: IContextualMenuItem[]) {
    return {
        items: menuItems ? menuItems : null,
        gapSpace: 0,
        styles: {
            container: { width: VIEW_SWITCHER_MENU_WIDTH },
            list: { width: VIEW_SWITCHER_MENU_WIDTH },
        },
    };
}
